import Abstract from './abstract';
import $ from 'jquery';

const CONTAINER = '[data-voc-pw-ip-limit-session]';

class MultiSession extends Abstract {
  constructor() {
    super(CONTAINER, ...arguments);
    this.priority   = -4;
    this.final      = true;
  }

  show() {
    const container$ = $(CONTAINER);

    if (container$.length && container$.is(':visible') && this.concurrentSessionLimit()) {
      Abstract.canNotViewContent();
      document.querySelector('[data-voc-reload-button]').addEventListener('click', (e) =>
        this.clickButton(e)
      );
    }
  }

  clickButton(e){
    e.preventDefault();
    window.location.reload();
  }

}

export default MultiSession;



// WEBPACK FOOTER //
// ./src/alerts/multi-session-ip.js